import { Helmet } from "react-helmet";
import {
  SITE_NAME,
  TITLE_SUFFIX,
  DEFAULT_OG_IMAGE,
  canonical,
} from "../../../config/seo";

type Props = {
  // Seitentitel ohne Suffix. Auf der Startseite via `titleOverride` steuerbar.
  title: string;
  description: string;
  // Pfad der aktuellen Seite für Canonical/OG-URL, z.B. "/rechtsanwaelte".
  path: string;
  image?: string;
  type?: "website" | "article";
  // Wenn true, wird der Titel unverändert übernommen (kein Suffix).
  titleOverride?: boolean;
  noindex?: boolean;
  // Ein oder mehrere JSON-LD-Objekte (strukturierte Daten).
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const Seo: React.FC<Props> = ({
  title,
  description,
  path,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  titleOverride = false,
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = titleOverride ? title : `${title}${TITLE_SUFFIX}`;
  const url = canonical(path);
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <html lang="de" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,follow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {blocks.map((block, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
